module.exports = __webpack_public_path__ + "img/insert.585e4fc4.svg";